import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalService, ModalDirective } from 'ngx-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IOption } from 'ng-select';
import { IntegrateLoyaltyViewServices } from '../services/integrate-loyalty-view.services';
import { ImageService } from '../../../../imageService';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-integrate-loyalty-view-stamp',
  templateUrl: './integrate-loyalty-view-stamp.component.html',
  styleUrls: ['./integrate-loyalty-view-stamp.component.css'],
  providers: [IntegrateLoyaltyViewServices]
})

export class IntegrateLoyaltyViewStampComponent implements OnInit {

  @ViewChild('pauseCampaign') pauseCampaign: ModalDirective;
  @ViewChild('activeCampaign') activeCampaign: ModalDirective;
  @ViewChild('removeCampaign') removeCampaign: ModalDirective;
  has_list = false;
  params: any = {};
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  public current_filter: any = {};
  public list_items: any = [];
  public item_detail: any = {};
  public FormFilterSellout: FormGroup;

  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;
  public total_data_history: number = 0
  public errorMessage: string = '';
  public item_active: number = 0;
  loadingDetail: boolean = false;

  /** Config status */

  sellout_actived = 1;
  sellout_pause = 0;

  list_status_filter: Array<IOption> = [
    { value: this.sellout_actived.toString(), label: 'Kích hoạt' },
    { value: this.sellout_pause.toString(), label: 'Tạm dừng' },
  ];

  /** Config service */
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  /** Config priority services */
  code_no_priority = 0;
  code_priority = 1;
  code_guarantee = 2;


  subcribe: Subscription = null;
  isCrating: Boolean = false;

  constructor(
    private integrateLoyaltyService: IntegrateLoyaltyViewServices,
    private fb: FormBuilder,
    private imageService: ImageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pagerService: PagerService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.subcribe = this.modalService.onHide.subscribe(() => {
      this.viewDetail(this.item_active);
    });

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  updateTranslations() {
    this.list_status_filter = [
      { value: this.sellout_actived.toString(), label: this.translate.instant('KICH_HOAT') },
      { value: this.sellout_pause.toString(), label: this.translate.instant('TAM_DUNG') },
    ];

    setTimeout(() => {
      $('#status_stamp').select2({
        placeholder: this.translate.instant('TRANG_THAI'),
        allowClear: false,
        minimumResultsForSearch: -1,
        width: '100%'
      });

      $('.slt-batchstamp').select2({
        placeholder: this.translate.instant('CHON_LO_TEM'),
        allowClear: true,
        width: '100%',
        ajax: {
          delay: 500,
          url: `${environment.api_evs}/batches`,
          headers: {
            Authorization: `${localStorage.getItem('Access-Token')}`,
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            $('.select2-container').addClass('setIndex-1800');
            return {
              name: params.term, // search term
              offset: params.page || 1,
              limit: 10,
            };
          },
          // tslint:disable-next-line:no-shadowed-variable
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.data.batches,
              pagination: {
                more: params.page + 10 < data.data.total[0].count
              }
            };
          },
        },
        templateResult: this.formatRepo,
        templateSelection: this.formatRepoSelection,
        minimumResultsForSearch: 1,
      });

      if (!this.has_list && this.total_data_history == 0 && this.isLink) {
        this.errorMessage = this.translate.instant('KHONG_CO_DU_LIEU_1');
      }
    }, 50);
  }

  ngOnInit() {
    this.updateTranslations();
    $('.selectpicker').selectpicker({
      style: 'btn-select',
      iconBase: 'icon',
      tickIcon: 'wb-check',
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.params.status = params.status;
      this.loadData(this.params);
    });
    this.createFormFilter();
  }

  createFormFilter() {
    this.FormFilterSellout = this.fb.group({
      // service: [[]],
      status: [this.params.status],
      created_time_ranger: [null],
      serial: [null],
    });
  }

  formatRepo(repo) {
    if (repo.loading) {
      return repo.text;
    }
    const $container = $(
      `<div class='select2-result-repository__title'>${repo.name}</div>`
    );
    return $container;
  }

  formatRepoSelection = (repo) => {
    if (repo.id == '') {
      return this.translate.instant('CHON_LO_TEM');
    }
    return repo.name || repo.name;
  }
  public isLink = false;

  public loadData(request: any = null) {
    const data_get: any = request ? request : this.current_filter;
    data_get.page = this.pageIndex
    data_get.size = this.page_size
    data_get.systemType = 1
    data_get.applyFor = 1
    this.integrateLoyaltyService.loyaltyHistory(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.total_data_history = res.data.pagination.totalElements;
          let list: any = [];
          let serial = '';
          for (let _data of res.data.items) {
            if (_data.idStart === _data.idEnd) {
              serial = this.formatSerial(_data.idStart, _data.prefix.toUpperCase())
            } else {
              serial = this.formatSerial(_data.idStart, _data.prefix.toUpperCase())
                + '-->' +
                this.formatSerial(_data.idEnd, _data.prefix.toUpperCase())
            }
            let obj = {
              id: _data.id,
              serial: serial,
              prefix: _data.prefix,
              idStart: _data.idStart,
              idEnd: _data.idEnd,
              campaignName: _data.campaignName,
              productName: _data.productName,
              createdAt: _data.createdAt,
              status: _data.status,
              image: this.imageService.readSrcImage(_data.productImage, 'thumb_large'),
            };
            list.push(obj);
          }
          this.list_items = list;
          console.log('do dai', list.length)
          this.item_active = 0
          if (list.length > 0) {
            this.has_list = true;
            this.isLink = true;
            this.loadingDetail = true
            this.viewDetail(0);
          } else {
            this.has_list = false;
            this.loadingDetail = true
            this.item_detail = null;
            this.isLink = true;
          }
        } else {
          this.errorMessage = res.message
          this.has_list = false;
          this.loadingDetail = true
          this.item_detail = null;
        }
      })
      .catch((err: any) => {
        console.log('getlistSellout:catch 123123', err);
      })
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadData();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    // this.loading_left = true;
    this.loadData();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      // this.loading_left = true;
      this.loadData();
    }
  }

  selloutId: any;

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: 'CHONG_GIA' });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: 'BAO_HANH' });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: 'TRAN_HANG' });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({ code: this.code_dinhdanh, name: 'DINH_DANH' });
    }
    return arr_services;
  }

  convertPriorityServiceToText(service: string) {
    let arr_priority_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_no_priority.toString()) != -1) {
      arr_priority_services.push({ code: this.code_no_priority, name: 'Không ưu tiên' });
    }
    if (service.indexOf(this.code_priority.toString()) != -1) {
      arr_priority_services.push({ code: this.code_priority, name: 'Ưu tiên dịch vụ chống giả' });
    }
    if (service.indexOf(this.code_guarantee.toString()) != -1) {
      arr_priority_services.push({ code: this.code_guarantee, name: 'Ưu tiên dịch vụ bảo hành' });
    }
    return arr_priority_services;
  }

  formatSerial(id: any, prefix: string) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  public viewDetail(i) {
    console.log(1, i);
    this.item_active = i;
    // this.loadingDetail = true;
    if (this.isCrating == true) {
      this.toastr.warning('Thao tác gán chương trình đã bị hủy', 'Thông báo:', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    $('.page-layout-detail').animate(
      { scrollTop: 0 },
      0,
      'swing',
      function () {
      }
    );
    this.isCrating = false;
    this.selloutId = this.list_items[i].id,
      this.integrateLoyaltyService
        .loyaltyDetail(this.list_items[i].id)
        .toPromise()
        .then((res: any) => {
          if (res.code == 1) {
            let serial = '';

            if (res.data.idStart === res.data.idEnd) {
              serial = this.formatSerial(res.data.idStart, res.data.prefix.toUpperCase())
            } else {
              serial = this.formatSerial(res.data.idStart, res.data.prefix.toUpperCase())
                + '-->' +
                this.formatSerial(res.data.idEnd, res.data.prefix.toUpperCase())
            }

            let arr_services = this.convertServiceToText(res.data.services);

            this.item_detail = {
              batchCreatedAt: res.data.batchCreatedAt,
              batchName: res.data.batchName,
              campaignCreatedAt: res.data.campaignCreatedAt,
              campaignImage: this.imageService.readSrcImage(
                res.data.campaignImage,
                'thumb_medium'
              ),
              campaignName: res.data.campaignName,
              campaignStatus: res.data.campaignStatus,
              id: res.data.id,
              serial: serial,
              idEnd: res.data.idEnd,
              idStart: res.data.idStart,
              prefix: res.data.prefix,
              productImage: this.imageService.readSrcImage(
                res.data.productImage,
                'thumb_medium'
              ),
              productName: res.data.productName,
              arr_services: arr_services,
              status: res.data.status,
              priorityService: res.data.priorityService,
              giftCode: res.data.giftCode,
            }
          } else {
            console.log('getSelloutDetail:error', res);
          }
        })
        .catch((err) => {
          console.log('getSelloutDetail:catch', err);
        });
  }

  submitFilterSellout(data: any = {}) {
    this.pageIndex = 1;
    let data_filter: any = {};

    if (data.service && data.service.length > 0) {
      data_filter.service = data.service.toString();
    }

    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#status_stamp').val()) {
      data_filter.status = $('#status_stamp').val();
    }
    if (data.created_time_ranger) {
      data_filter.from = moment(data.created_time_ranger[0]).format(
        'DD-MM-YYYY'
      );
      data_filter.to = moment(data.created_time_ranger[1]).format('DD-MM-YYYY');
    }
    if ($('.slt-batchstamp').val()) {
      data_filter.batchId = $('.slt-batchstamp').val();
    }

    this.current_filter = data_filter;
    this.loadData();
  }

  ResetFormSearch() {
    $('#filter_service').selectpicker('val', '');
    $('#status_stamp').val('').trigger('change');
    $('.slt-batchstamp').val('').trigger('change');
    this.FormFilterSellout.reset();
  }

  showCreate() {
  }

  pauseCampaignSellout() {
    this.pauseCampaign.show();
  }

  handlePauseCampaign() {
    console.log('id tuan test', this.item_detail.id)
    let body = {
      logIds: [this.item_detail.id],
      status: 0
    }
    this.integrateLoyaltyService.updateLoyaltyCampaign(body)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.warning('Tạm dừng chiến dịch thành công', 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.pauseCampaign.hide();
          this.loadData()
          return;
        } else {
          this.toastr.warning(`${res.message}`, 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

    console.log('vào xác nhận chưa')
  }

  activeCampaignSellout() {
    this.activeCampaign.show();
  }

  handleActiveCampaign() {
    console.log('id tuan test', this.item_detail.id)
    let body = {
      logIds: [this.item_detail.id],
      status: 1
    }
    this.integrateLoyaltyService.updateLoyaltyCampaign(body)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.success('Kích hoạt chiến dịch thành công', 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.activeCampaign.hide();
          this.loadData()
          return;
        } else {
          this.toastr.warning(`${res.message}`, 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

    console.log('vào xác nhận chưa')
  }


  removeSellout() {
    this.removeCampaign.show();
  }

  handleRemoveCampaign() {
    console.log('id tuan test', this.item_detail.id)
    let logIds = [this.item_detail.id]
    console.log('id khi xoa ', logIds);
    this.integrateLoyaltyService.removeLoyaltyCampaign(logIds)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.success('Xóa chiến dịch thành công', 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.removeCampaign.hide();
          this.loadData()
          return;
        } else {
          this.toastr.warning(`${res.message}`, 'Thông báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

    console.log('vào xác nhận chưa')
  }

  showCrating() {
    console.log('cau hinh sale out:')
    this.isCrating = true;
    // this.isCreate = false;
    // this.isUpdate = false;
    // this.isDistribution = false;
    // this.isActive = false;
  }

  hideCrating(event) {
    console.log(event)
    // this.isCreate = false;
    this.isCrating = false;
    // this.isUpdate = false;
    if (event.isBack == false) {
      // delete this.arr_sort['created_time'];
      // this.setSort('created_time', 'desc');
      this.current_filter = {};
      this.pageIndex = 1;
      this.loadData();
    }
    if (event.updated == true) {
      this.viewDetail(this.item_active);
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-view-stamp/integrate-loyalty-view-stamp.component.ts